<template>
  <depart />
</template>

<script>
// 目前两个页面一样,直接引用
// 如果此页面有单独更改,全部复制工程的页面过来再改
import depart from '../project/depart.vue'
export default {
  components: {
    depart
  },
  data() {
    return {};
  },
};
</script>